import { clsx } from 'clsx';
import type { HTMLAttributes, ReactNode } from 'react';

type Surface = 'canvas' | 'stone' | 'pale-blue' | 'pale-green' | 'dark' | 'dark-navy';

export interface SectionProps extends HTMLAttributes<HTMLElement> {
  surface?: Surface;
  container?: boolean;
  children: ReactNode;
}

const surfaceClass: Record<Surface, string> = {
  canvas: 'bg-canvas-white text-ink',
  stone: 'bg-soft-stone text-ink',
  'pale-blue': 'bg-pale-blue-wash text-ink',
  'pale-green': 'bg-pale-green-wash text-ink',
  dark: 'bg-deep-enterprise-green text-canvas-white',
  'dark-navy': 'bg-dark-navy text-canvas-white',
};

export function Section({ surface = 'canvas', container = true, className, children, ...rest }: SectionProps) {
  return (
    <section {...rest} className={clsx(surfaceClass[surface], 'py-12 sm:py-16 md:py-20 lg:py-section', className)}>
      {container ? <div className="container-editorial">{children}</div> : children}
    </section>
  );
}

export function SectionEyebrow({ children, tone = 'muted' }: { children: ReactNode; tone?: 'muted' | 'inverted' }) {
  return (
    <p className={clsx('mono-label', tone === 'inverted' ? 'text-canvas-white/70' : 'text-muted-slate')}>
      {children}
    </p>
  );
}

export function SectionTitle({ children, size = 'section-heading', className }: { children: ReactNode; size?: 'hero' | 'product-display' | 'section-display' | 'section-heading' | 'card-heading' | 'feature-heading'; className?: string }) {
  return (
    <h2
      className={clsx(
        'font-display text-balance text-ink mt-3',
        size === 'hero' && 'text-hero',
        size === 'product-display' && 'text-product-display',
        size === 'section-display' && 'text-section-display',
        size === 'section-heading' && 'text-section-heading',
        size === 'card-heading' && 'text-card-heading',
        size === 'feature-heading' && 'text-feature-heading',
        className
      )}
    >
      {children}
    </h2>
  );
}
